// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"44105b7e","388":"4ba549c8","632":"1d99c59d","657":"a51893e3"}[chunkId] + ".css";
};